<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <Createkcopcriteriaaspect ref="createkcopcriteria" :kcop_criteria_id="id" @update_criteria="get_kcop_criteria" />
        <Aspectoptions ref="aspectoptions" @update_aspects="get_kcop_criteria()" />
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <Windelete ref="windelete" @delete_record="delete_kcop_criteria" />
        <div class="content">
            <div class="content-header">
                <Backbutton />
               Аспекты критериев оценки КЦОП {{ id }}
            </div><br>
            <div class="btn_add" @click="$refs.createkcopcriteria.is_window_show = true">Добавить аспект</div>
            <table>
                <tr>
                    <th>ID</th>
                    <th>Наименование</th>
                    <th>Тип</th>
                    <th>Аббревиатура</th>
                    <th>Значение</th>
                    <th></th>
                </tr>
                <tr v-for="key in kcop_criteria" :key="key.id">
                    <td>{{ key.id }}</td>
                    <td>{{ key.name}}</td>
                    <td>{{ aspect_types[key.aspect_type] }}</td>
                    <td>{{ key.abbreviation }}</td>
                    <td>{{ key.value }}</td>
                    <td>
                        <Btn_edit v-if="key.aspect_type == 1" @click="edit_options(key.id)" />
                        <Btn_delete @click="delete_kcop_criteria_window(key.id)" />
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>

import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Btn_delete from '@/components/elements/svg/btn_delete.vue'
import Btn_edit from '@/components/elements/svg/btn_edit.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Windelete from '@/components/windows/win_delete_common.vue'
import Createkcopcriteriaaspect from '@/components/kcopcriteria/create_kcopcriteriaaspect.vue'
import Aspectoptions from '@/components/kcopcriteria/aspect_options.vue'

export default {
    name: 'Kcop',
    components: {
        Success, Error, Btn_delete, Backbutton, Windelete, Createkcopcriteriaaspect, Btn_edit, Aspectoptions
    },
    props: {
        id: String
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            kcop_criteria: {},
            permissions: {},
            aspect_types: {
                1: 'Дискретный',
                2: 'Бинарынй'
            }
        }
    },
    methods: {
        edit_options(id) {
            this.$refs.aspectoptions.kcop_aspect_id = id
            this.$refs.aspectoptions.is_window_show = true
            this.$refs.aspectoptions.get_options()
        },
        get_kcop_criteria() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop_criteria_aspects/'+this.id)
                .then(response => {
                    this.kcop_criteria = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        delete_kcop_criteria_window(id) {
            this.$refs.windelete.record_id = id
            this.$refs.windelete.is_window_show = true
        },
        delete_kcop_criteria(id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.delete(process.env.VUE_APP_API_URL + '/api/kcop_criteria_aspects/'+id)
                .then(response => {
                    console.log(response.data.data)
                    this.get_kcop_criteria()
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
    },
    created() {
        this.get_kcop_criteria()
    }
}

</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>